import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '@/contexts/CartContext';

const CheckoutProcessingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { clearCart } = useCart();
  
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Processing your order...');

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const stripeSessionId = queryParams.get('session_id');
    const legacyOrderId = queryParams.get('orderId');

    if (stripeSessionId) {
      // Stripe checkout was successful. The actual fulfillment logic
      // is handled by webhooks, so we just show a success message
      // and clear the cart.
      setStatus('success');
      setMessage('Your order has been placed successfully! A confirmation email will be sent shortly.');
      clearCart();
    } else if (legacyOrderId) {
      // This was likely a Square order or another legacy flow which is deprecated.
      setStatus('error');
      setMessage('The payment method used for this order is no longer supported. Please try placing your order again with our new checkout system.');
    } else {
      // No identifier found, this is an invalid state.
      setStatus('error');
      setMessage('Could not find a valid order identifier. Please return to your cart and try again.');
    }
  }, [location, clearCart]);

  const handleReturnHome = () => {
    navigate('/');
  };

  return (
    <div className="container mx-auto max-w-lg text-center py-20">
      {status === 'loading' && (
        <>
          <h1 className="text-2xl font-semibold mb-2">Processing...</h1>
          <p className="text-gray-600">{message}</p>
          {/* You can add a spinner here */}
        </>
      )}
      
      {status === 'success' && (
        <>
          <h1 className="text-3xl font-bold text-green-600 mb-4">Thank You!</h1>
          <p className="text-gray-700 mb-6">{message}</p>
          <button onClick={handleReturnHome} className="bg-blue-600 text-white py-2 px-6 rounded-lg hover:bg-blue-700">
            Continue Shopping
          </button>
        </>
      )}

      {status === 'error' && (
        <>
          <h1 className="text-3xl font-bold text-red-600 mb-4">Order Error</h1>
          <p className="text-gray-700 mb-6">{message}</p>
          <button onClick={handleReturnHome} className="bg-gray-600 text-white py-2 px-6 rounded-lg hover:bg-gray-700">
            Return to Homepage
          </button>
        </>
      )}
    </div>
  );
};

export default CheckoutProcessingPage;